<template>
    <flex-element :element-type="elementType" class="rich-text" class-default-inline="f-w-1/1">
        <div v-show="previewMode" v-html="renderTextPreview" />

        <div
            v-show="!previewMode"
            ref="richTextContent"
            :contenteditable="isContentEditable"
            @input="setChangedData(true)"
            @blur="onInput"
        />
    </flex-element>
</template>

<script>
import { mapMutations } from 'vuex';

import baseAtom from '@/mixins/base-atom/base-atom-smart';
import { ARichText } from '@/data/data-models';
import listenOnRootMixin from '@/mixins/listen-on-root';
import { SHOW_MODAL } from '@/store/types/mutation-types';

const PLACEHOLDER_TEXT = '[Text here]';

export default {
    name: 'a-rich-text',

    mixins: [baseAtom, listenOnRootMixin],

    props: {
        displayName: {
            type: String,
            default: 'Rich Text',
        },

        richText: {
            type: String,
            default: '',
        },

        templateId: {
            type: String,
            default: '{B3F93A72-5285-4C33-9728-F71F1B0F63EB}',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
            linkRegex: /href="~\/link.aspx/g,
            linkReplace: `href="${ process.env.VUE_APP_CM_URL }/link.aspx`,
            linkSitecoreRegex: new RegExp(`href="${ process.env.VUE_APP_CM_URL }/link.aspx`, 'g'),
            linkSitecoreReplace: 'href="~/link.aspx',
            mediaRegex: /src="-\/media\//g,
            mediaReplace: `src="${ process.env.VUE_APP_CM_URL }/-/media/`,
            mediaSitecoreRegex: new RegExp(`src="${ process.env.VUE_APP_CM_URL }/-/media/`, 'g'),
            mediaSitecoreReplace: 'src="-/media/',
            mediaLinkRegex: /href="-\/media\//g,
            mediaLinkReplace: `href="${ process.env.VUE_APP_CM_URL }/-/media/`,
            mediaLinkSitecoreRegex: new RegExp(`href="${ process.env.VUE_APP_CM_URL }/-/media/`, 'g'),
            mediaLinkSitecoreReplace: 'href="-/media/',
            richTextNew: '',
        };
    },

    computed: {
        renderTextPreview() {
            return this.richTextNew.includes(PLACEHOLDER_TEXT) ? '' : this.richTextNew;
        },

        updatedElement() {
            return new ARichText({
                ...this.updatedBaseElement,
                richText: this.linkConvertedOutput,
            });
        },

        linkConvertedOutput() {
            // replace link and media urls
            let updatedUrlsRt = this.richTextNew.replace(this.linkSitecoreRegex, this.linkSitecoreReplace);
            updatedUrlsRt = updatedUrlsRt.replace(this.mediaSitecoreRegex, this.mediaSitecoreReplace);
            updatedUrlsRt = updatedUrlsRt.replace(this.mediaLinkSitecoreRegex, this.mediaLinkSitecoreReplace);
            return updatedUrlsRt;
        },
    },

    created() {
        this.listenOnRoot('flex::rich-text::save', this.onModalSave);
    },

    mounted() {
        this.setHtml();
    },

    methods: {
        ...mapMutations({
            showModal: SHOW_MODAL,
        }),

        setSitecoreUrls(richText) {
            let urlsChanged = richText;
            urlsChanged = urlsChanged.replace(this.linkRegex, this.linkReplace);
            urlsChanged = urlsChanged.replace(this.mediaRegex, this.mediaReplace);
            urlsChanged = urlsChanged.replace(this.mediaLinkRegex, this.mediaLinkReplace);
            return urlsChanged;
        },

        setFieldValues() {
            this.richTextNew = this.setSitecoreUrls(this.richText);
        },

        setHtml() {
            this.$refs.richTextContent.innerHTML = this.richTextNew
                || (this.$slots.default ? this.$slots.default[0].text.trim() : PLACEHOLDER_TEXT);
        },

        onEditHtml() {
            const editorEl = this.$refs.richTextContent;

            this.showModal({
                componentTag: 'rich-text-modal',
                data: {
                    elementId: this.id,
                    html: editorEl.innerHTML,
                    rteType: 'normal',
                },
            });
        },

        onModalSave(id, html) {
            if (this.id !== id) return;

            this.$refs.richTextContent.innerHTML = html;
            this.richTextNew = html;
            this.setChangedData(true);
        },

        onInput() {
            const isEmpty = this.$refs.richTextContent.innerText.trim().includes(PLACEHOLDER_TEXT);
            this.richTextNew = isEmpty ? '' : this.$refs.richTextContent.innerHTML;
        },
    },
};
</script>
